import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import InsuranceTwoToneSvg from "@ant-design/icons-svg/es/asn/InsuranceTwoTone";
import AntdIcon from "../components/AntdIcon";
var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsuranceTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  InsuranceTwoTone.displayName = 'InsuranceTwoTone';
}
export default /*#__PURE__*/React.forwardRef(InsuranceTwoTone);